import MaskAutoCompleteRecipientRequest from 'owa-service/lib/contract/MaskAutoCompleteRecipientRequest';
import MaskAutoCompleteRecipientResponse from 'owa-service/lib/contract/MaskAutoCompleteRecipientResponse';
import maskAutoCompleteRecipientOperation from 'owa-service/lib/operation/maskAutoCompleteRecipientOperation';
import maskAutoCompleteRecipientRequest from 'owa-service/lib/factory/maskAutoCompleteRecipientRequest';

function configureRequestBody(emailAddress: string): MaskAutoCompleteRecipientRequest {
    return maskAutoCompleteRecipientRequest({
        EmailAddress: emailAddress,
    });
}

export function maskAutoCompleteRecipient(
    emailAddress: string
): Promise<MaskAutoCompleteRecipientResponse> {
    let requestBody = configureRequestBody(emailAddress);
    return maskAutoCompleteRecipientOperation(requestBody).then(response => {
        let responseMessage: MaskAutoCompleteRecipientResponse = response;
        return responseMessage;
    });
}
